import { ROUTES } from 'src/config/routeConfig';

export const AUTO_GENERATED_ENTITY_IDENTIFIERS_WORKFLOW_IDS : string[] = ['14784848-8b23-4803-a581-a3480b5fae81', '176eb9a9-18f8-4072-9868-92aea6c4b623'];
export const CONFIGURE_CNAME_WORKFLOW_REGION = 'NA';
export const REGIONS = [
	{
		label: 'NA',
		id: 'NA',
	},
	{
		label: 'EU',
		id: 'EU',
	},
	{
		label: 'JP',
		id: 'JP',
	},
];

export const AWS_REGIONS = [
	{ label: 'IAD', value: 'us-east-1' },
	{ label: 'NRT', value: 'ap-northeast-1' },
	{ label: 'DUB', value: 'eu-west-1' },
	{ label: 'ZAZ', value: 'eu-south-2' },
	{ label: 'PDX', value: 'us-west-2'},
];

export const REVIEW_COLUMNS = [
	{
		id: 'attribute',
		header: 'Attribute',
		cell: (e) => e.attribute,
	},
	{
		id: 'value',
		header: 'Value',
		cell: (e) => e.value,
	},
];

export const COUNTRIES = {
	NA: [
		{
			label: 'United States',
			id: 'US',
		},
		{
			label: 'Brazil',
			id: 'BR',
		},
		{
			label: 'Canada',
			id: 'CA',
		},
		{
			label: 'Mexico',
			id: 'MX',
		},
	],
	EU: [
		{
			label: 'India',
			id: 'IN',
		},
		{
			label: 'United Kingdom',
			id: 'GB',
		},
		{
			label: 'Germany',
			id: 'DE',
		},
		{
			label: 'Italy',
			id: 'IT',
		},
		{
			label: 'Spain',
			id: 'ES',
		},
		{
			label: 'Poland',
			id: 'PL',
		},
		{
			label: 'Ireland',
			id: 'IE',
		},
		{
			label: 'France',
			id: 'FR',
		},
		{
			label: 'United Arab Emirates',
			id: 'AE',
		},
		{
			label: 'Turkey',
			id: 'TR',
		},
		{
			label: 'Sweden',
			id: 'SE',
		},
		{
			label: 'Saudi Arabia',
			id: 'SA',
		},
		{
			label: 'Egypt',
			id: 'EG',
		},
	],
	JP: [
		{
			label: 'Japan',
			id: 'JP',
		},
		{
			label: 'Singapore',
			id: 'SG',
		},
		{
			label: 'Australia',
			id: 'AU',
		},
	],
};

export const COUNTRY_NAME_TO_CODE_MAPPING = {
	'United States': 'US',
	Brazil: 'BR',
	Canada: 'CA',
	Mexico: 'MX',
	Colombia: 'CO',
	Chile: 'CL',
	India: 'IN',
	'United Kingdom': 'GB',
	France: 'FR',
	Italy: 'IT',
	Spain: 'ES',
	Poland: 'PL',
	Germany: 'DE',
	Slovakia: 'SK',
	'Czech Republic': 'CZ',
	'United Arab Emirates': 'AE',
	'Saudi Arabia': 'SA',
	Egypt: 'EG',
	Turkey: 'TR',
	Sweden: 'SE',
	Ireland: 'IE',
	Nigeria: 'NG',
	'South Africa': 'ZA',
	Netherlands: 'NL',
	Japan: 'JP',
	Singapore: 'SG',
	Australia: 'AU',
	Malaysia: 'MY',
};

export const FC_NODE_PROPERTIES = {
	kiva: 'Amazon Robotics',
	fresh: 'Fresh Integration',
	pantry: 'Pantry',
	magic: 'Magic',
	customer_returns: 'Customer Returns',
	fdfc: 'FDFC',
	supplemental_fc: 'Supplemental FC',
	ixd: 'IXD',
	prime_now_hub: 'Prime Now Hub',
	aft_x: 'AFT-X',
	pod: 'Print on Demand',
	ssd: 'SSD',
};

export const snowIssueTemplate =
	'https://sim.amazon.com/issues/create?template=95bff7ef-895c-48a9-8b89-88dcd0217732';

export const completedStatuses = [
	'COMPLETED',
	'OVERRIDEN',
	'REMOVED',
	'CANCELLED',
];
export const DRAFT_STATE = 'DRAFT';
export const SUBMITTED_STATE = 'READY';

export const NO_ITEMS_FOUND = 'No Items found';
export const NO_MATCHES_FOUND = 'No matches found for your query';

export const RIVER_SNOW_CONTACT_US_LINK =
	'https://river.amazon.com/HYD13/workflows?buildingType=SNOW&q0=SNOW%20report%20Issue&id=9cffdb1b-0d0a-42f5-8988-94c41bf465f8';
export const ERROR_MESSAGES = {
	permissions: 'Error while getting the permissions: ',
	apiError: 'Failed to collect required information about the Node: ',
};
export const QUERY_PARAMS = {
	TAB: 'tab',
	SERVICE_NAME: 'service_name',
	REVIEW_ID: 'review_id',
	POD_NAME: 'pod_name',
	FLASHBAR_HEADER: 'flashbar_header',
	FLASHBAR_TYPE: 'flashbar_type',
	CONFIGURATION_ID: 'configuration_id',
};

export const PAGE_LINKS = {
	HOME: ROUTES.ROOT,
	VIEW_REVIEW: ROUTES.VIEW_REVIEW,
	LIST_REVIEWS: ROUTES.LIST_REVIEWS,
	VIEW_HOSTED_CONFIG: ROUTES.VIEW_HOSTED_CONFIG,
	ONBOARD_SERVICE: ROUTES.ONBOARD_SERVICE,
	APP_CONFIG_REVIEW_DASHBOARD: ROUTES.APP_CONFIG_REVIEW_DASHBOARD,
	FC_TO_POD_MAPPINGS_DASHBOARD: ROUTES.FC_TO_POD_MAPPINGS_DASHBOARD,
	ALERT_NODES_DASHBOARD: ROUTES.ALERT_NODES_DASHBOARD,
};

export const PAGE_LINKS_WITH_HASH = {
	HOME: ROUTES.ROOT,
	VIEW_REVIEW: '/#' + ROUTES.VIEW_REVIEW,
	LIST_REVIEWS: '/#' + ROUTES.LIST_REVIEWS,
	VIEW_HOSTED_CONFIG: '/#' + ROUTES.VIEW_HOSTED_CONFIG,
	ONBOARD_SERVICE: '/#' + ROUTES.ONBOARD_SERVICE,
	APP_CONFIG_REVIEW_DASHBOARD: '/#' + ROUTES.APP_CONFIG_REVIEW_DASHBOARD,
};

export const HTTP_REQUEST_METHODS = {
	GET: 'GET',
	POST: 'POST',
	PUT: 'PUT',
	PATCH: 'PATCH',
	DELETE: 'DELETE',
};

export const DEPLOYMENT_STRATEGY_REFERENCE_LINK =
	'https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-creating-deployment-strategy.html';

export const IAM_ROLE_REFERENCE_LINK =
	'https://w.amazon.com/bin/view/SNOW_Team_Design_Documents/AWSAppConfigTaskOnboarding/';

export const RECOMMENDED_DEPLOYMENT_STRATEGY =
	'AppConfig.Canary10Percent20Minutes';

export const mapDateFromatter = {
	weekday: 'long',
	year: 'numeric',
	month: 'long',
	day: 'numeric',
} as const;

export const SOMETHING_WENT_WRONG =
	'Something went wrong. Please try again later.';
export const USER_IS_OFFLINE = 'You are offline. Please try to reconnect';

export const USER_BADGE_PHOTO_URL = 'https://badgephotos.corp.amazon.com/';
export const AUTOPOPULATION_TASK_FUNCTION_NAME =
	'AutoPopulateEntityParametersProxy';
export const AUTOPOPULATION_OPTIONS_FIELD_PREFIX = '__autoPopOptions';
export const BINDLE_URL = 'https://bindles.amazon.com/resource/';
export const INVALID_STRING_REGEX = '^(\\S.*\\S|\\S)$'; //Regex to check if the atrribute value is blank or has leading/trailing white spaces

export const SNOW_CREATE_SIM_ISSUES_LINK =
	'https://river.amazon.com/HYD13/workflows?buildingType=SNOW&q0=9cffdb1b-0d0a-42f5-8988-94c41bf465f8&id=9cffdb1b-0d0a-42f5-8988-94c41bf465f8';
export const STATUSES_WITHOUT_EXECUTION_DATA: string[] = ['SUBMITTED', 'DRAFT', 'PENDING_APPROVAL'];
export const UNICODE_REGEX = /[\p{Letter}\p{Mark}\s\d-]+/gu;

export const NOT_APPLICABLE = 'N/A';

// TODO: Need to removed later when we have an automated way of getting approvers name, group in workflow defintion.
export const SCD_WORKFLOW_APPROVER = 'scd-workflow-approver';

export const SUB_WORKFLOW_TASK_TYPE = 'SubWorkflow';
